import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { subscribeTable } from '../lib/realtime';

export type DriverAppRow = {
  id: string;
  driver_id: string;
  app_name: string;
  status: 'connected' | 'paused' | 'disconnected';
  created_at: string;
};

export function useDriverApps(driverId: string | undefined) {
  const [apps, setApps] = useState<DriverAppRow[]>([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    if (!driverId) return;
    const { data } = await supabase
      .from('driver_apps')
      .select('*')
      .eq('driver_id', driverId)
      .order('app_name');
    setApps((data ?? []) as DriverAppRow[]);
    setLoading(false);
  }, [driverId]);

  useEffect(() => {
    if (!driverId) {
      setLoading(false);
      return;
    }
    refetch();
    const unsub = subscribeTable('driver_apps', refetch, `driver_id=eq.${driverId}`);
    return unsub;
  }, [driverId, refetch]);

  return { apps, loading, refetch };
}
